import { proxyCustomElement, HTMLElement, h, Host } from '@stencil/core/internal/client';
import { r as remCalc } from './index5.js';
import './index3.js';
import { d as defineCustomElement$2 } from './roche-icon2.js';

var RocheEmergencyBannerState;
(function (RocheEmergencyBannerState) {
    RocheEmergencyBannerState["DISMISSED"] = "dismissedEmergencyBanner";
})(RocheEmergencyBannerState || (RocheEmergencyBannerState = {}));

const rocheEmergencyBannerCss = ":host{display:block;margin-top:3rem;z-index:300;transition:opacity 150ms ease-in, transform 200ms ease-in;opacity:0;pointer-events:none;transform:translateY(100%);position:fixed;bottom:0;width:100%;background-color:#fff;padding:1rem 0 0;box-shadow:0 -0.3125rem 0.9375rem rgba(0, 0, 0, 0.2)}@media (min-width: 90rem){:host{margin-top:4.5rem}}:host,:host *{box-sizing:border-box}:host .close{position:absolute;left:0;right:0;margin:auto;color:#544f4f;fill:#544f4f;display:flex;justify-content:flex-end;max-width:calc(100% - 40px)}@media (min-width: 48rem){:host .close{max-width:calc(100% - 64px)}}@media (min-width: 64rem){:host .close{max-width:calc(100% - 128px)}}@media (min-width: 90rem){:host .close{max-width:calc(100% - 192px)}}@media (min-width: 104.5rem){:host .close{max-width:1552px}}:host .close-icon{cursor:pointer}:host(.visible){transition:opacity 150ms ease-out 50ms, transform 200ms ease-out;opacity:1;pointer-events:auto;transform:translateY(0)}";
const RocheEmergencyBannerStyle0 = rocheEmergencyBannerCss;

const RocheEmergencyBanner$1 = /*@__PURE__*/ proxyCustomElement(class RocheEmergencyBanner extends HTMLElement {
    constructor() {
        super();
        this.__registerHost();
        this.__attachShadow();
        this.userHasDismissedBanner = false;
        this.visible = false;
        this.hideBanner = this.hideBanner.bind(this);
    }
    async componentWillLoad() {
        this.userHasDismissedBanner = JSON.parse(sessionStorage.getItem(RocheEmergencyBannerState.DISMISSED)) === true;
        // delay visibility so user may observe the banner "sliding in"
        if (!this.userHasDismissedBanner) {
            window.setTimeout(() => { this.visible = true; }, 1500);
        }
    }
    render() {
        if (this.userHasDismissedBanner) {
            return null;
        }
        const hostClasses = {
            visible: this.visible,
        };
        return (h(Host, { class: hostClasses }, h("div", { class: "close" }, h("roche-icon", { class: "close-icon", icon: "mobile-close", height: `${remCalc(32)}rem`, onClick: this.hideBanner })), h("slot", { name: "content" })));
    }
    hideBanner() {
        window.sessionStorage.setItem(RocheEmergencyBannerState.DISMISSED, 'true');
        this.visible = false;
    }
    static get style() { return RocheEmergencyBannerStyle0; }
}, [1, "roche-emergency-banner", {
        "userHasDismissedBanner": [32],
        "visible": [32]
    }]);
function defineCustomElement$1() {
    if (typeof customElements === "undefined") {
        return;
    }
    const components = ["roche-emergency-banner", "roche-icon"];
    components.forEach(tagName => { switch (tagName) {
        case "roche-emergency-banner":
            if (!customElements.get(tagName)) {
                customElements.define(tagName, RocheEmergencyBanner$1);
            }
            break;
        case "roche-icon":
            if (!customElements.get(tagName)) {
                defineCustomElement$2();
            }
            break;
    } });
}

const RocheEmergencyBanner = RocheEmergencyBanner$1;
const defineCustomElement = defineCustomElement$1;

export { RocheEmergencyBanner, defineCustomElement };

//# sourceMappingURL=roche-emergency-banner.js.map